import axios from 'axios';
import { getCreatorApiUrl } from '../components/api-urls';
import auth from '../components/auth';

const createWebhook = async ({ influencerId, trigger, webhookUrl }) => {
  const endpoint = getCreatorApiUrl(`/influencers/${influencerId}/webhooks`);

  const token = auth.getToken();

  const { data } = await axios.post(
    endpoint,
    { influencerId, trigger, webhookUrl },
    {
      headers: {
        Authorization: token,
      },
    },
  );

  return data;
};

const getWebhooks = async ({ influencerId }) => {
  const endpoint = getCreatorApiUrl(`/influencers/${influencerId}/webhooks`);

  const token = auth.getToken();

  const { data } = await axios.get(endpoint, {
    headers: {
      Authorization: token,
    },
  });

  return data;
};

const deleteWebhook = async ({ influencerId, webhookId }) => {
  const endpoint = getCreatorApiUrl(
    `/influencers/${influencerId}/webhooks/${webhookId}`,
  );

  const token = auth.getToken();

  const { data } = await axios.delete(endpoint, {
    headers: {
      Authorization: token,
    },
  });

  return data;
};

export const WebhooksApi = { createWebhook, getWebhooks, deleteWebhook };
